import { render, staticRenderFns } from "./CustomFieldModal.vue?vue&type=template&id=0afbd171&scoped=true"
import script from "./CustomFieldModal.vue?vue&type=script&lang=js"
export * from "./CustomFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afbd171",
  null
  
)

export default component.exports